module.exports = __webpack_public_path__ + "static/media/pricon.d79b782f.png";